@property --media-slider-fill {
  syntax: "<percentage>";
  inherits: true;
  initial-value: 0%;
}

@property --media-slider-buffer {
  syntax: "<percentage>";
  inherits: true;
  initial-value: 0%;
}
